export const errors = {
  TOO_MANY_VERIFY_ATTEMPTS_ERROR: 'TOO_MANY_VERIFY_ATTEMPTS_ERROR',
  DEFAULT_ERROR: 'AUTHORIZATION_DISPLAY_ERROR',
  TOO_MANY_ATTEMPTS_ERROR: 'TOO_MANY_ATTEMPTS_ERROR',
  INVALID_CODE_ERROR: 'INVALID_CODE_ERROR',
  CODE_VALIDATION_ERROR: 'CODE_VALIDATION_ERROR',
  CHALLENGE_DENIED_ERROR: 'CHALLENGE_DENIED_ERROR',
  CHALLENGE_ERROR: 'CHALLENGE_ERROR',
  USER_NOT_FOUND_ERROR: 'USER_NOT_FOUND_ERROR',
  MULTIPLE_SHOPPERS: 'MULTIPLE_SHOPPERS',
  INACTIVE_LOCKED_ACCOUNT: 'INACTIVE_OR_LOCKED_ACCOUNT',
  SEND_MAIL_ERROR: 'SEND_MAIL_ERROR',
  FAILED_TO_FETCH_ERROR: 'Failed to fetch',
  NETWORK_ERROR: 'NETWORK_ERROR',
  INFORMATION_DOES_NOT_MATCH_ERROR: 'INFORMATION_DOES_NOT_MATCH_ERROR',
  INELIGIBLE_ACCOUNT_ERROR: 'INELIGIBLE_ACCOUNT_ERROR',
  EXPIRED_ERROR: 'EXPIRED_ERROR',
  BILLING_ATTEMPTS_ERROR: 'BILLING_ATTEMPTS_ERROR',
  EMAIL_ATTEMPTS_ERROR: 'EMAIL_ATTEMPTS_ERROR',
  EMAIL_VALID_FORMAT_ERROR: 'EMAIL_VALID_FORMAT_ERROR',
  EMAIL_ALREADY_IN_USE: 'EMAIL_ALREADY_IN_USE',
  TWO_FACTOR_DELETE_RECOVER_INVALID_PERSONA_INQUIRY_STATUS: 'TWO_FACTOR_DELETE_RECOVER_INVALID_PERSONA_INQUIRY_STATUS',
  TWO_FACTOR_DELETE_RECOVERY_INVALID_INFO: 'TWO_FACTOR_DELETE_RECOVERY_INVALID_INFO',
  TWO_FACTOR_DELETE_RECOVERY_INELIGIBLE: 'TWO_FACTOR_DELETE_RECOVERY_INELIGIBLE',
  PERSONA_API_ERROR: 'PERSONA_API_ERROR',
  RATE_LIMIT_FOR_TAC_EXCEEDED: 'RATE_LIMIT_FOR_TAC_EXCEEDED',
  DEFAULT_FAILURE_STRING: 'DEFAULT_FAILURE_STRING',
  SMS_SEND_REQUEST_BLOCKED: 'SMS_SEND_REQUEST_BLOCKED',
  UNUSUAL_BROWSER: 'UNUSUAL_BROWSER',
  BILLING_INFO_MISMATCH_ERROR: 'BILLING_INFO_MISMATCH_ERROR',
};

export const loginErrors = {
  INVALID_REALM: 'INVALID_REALM',
  FAILED_LOGIN: 'FAILED_LOGIN',
  DEFAULT_FAILURE_STRING: 'DEFAULT_FAILURE_STRING',
  TIMER_LOCKED: 'TIMER_LOCKED',
  ACCOUNT_DOESNT_EXIST: 'ACCOUNT_DOESNT_EXIST',
  PASS_TEMP_PASSWORD_EXPIRED: 'PASS_TEMP_PASSWORD_EXPIRED',
  ACCOUNT_LOCKED: 'ACCOUNT_LOCKED',
  ACCOUNT_LOCKED_LOGIN: 'ACCOUNT_LOCKED_LOGIN',
  ACCOUNT_ALREADY_LINKED: 'ACCOUNT_ALREADY_LINKED',
  FAILED_TO_FETCH_ERROR: 'Failed to fetch',
};

export const contactTypes = Object.freeze({
  PHONE_WORK: 'phoneWork',
  EMAIL: 'email',
});

export const factorEmailTypes = Object.freeze({
  EMAIL: 'email',
  ADMIN_EMAIL: 'admin_email',
  RECOVERY_EMAIL: 'recovery_email',
});

export const cobrands = {
  MEDIATEMPLE: 'Media Temple',
  TSOHOST: 'tsoHost',
  'DAN.COM': 'Dan.com',
};

export const levelUpRecoveryState = {
  EMAIL_VERIFICATION: 'EMAIL_VERIFICATION',
  BILLING_VERIFICATION: 'BILLING_VERIFICATION',
  FULLY_VALIDATED: 'FULLY_VALIDATED',
  SUCCESSFULLY_DELETED: 'SUCCESSFULLY_DELETED',
};

export const emailValidationFields = {
  SIX_DIGITS_CODE: 'sixDigitCode',
};

export const billingInformationFields = {
  CARD_FIRST_SIX_DIGITS: 'cardFirstSixDigits',
  CARD_LAST_FOUR_DIGITS: 'cardLastFourDigits',
  EXPIRY: 'expiry',
};
export const PERSONA_DISABLE_2SV_PATH = '/account/security/persona/disable2sv';
export const DISABLE_2SV_PATH = '/login/levelup/disable-2sv';

export const BILLING = 'billing';
export const PERSONA = 'persona';

export const cohortIds = {
  CHECKOUT_LITE_CV: 'cv',
  CHECKOUT_LITE_NON_CV: 'non-cv',
};
